import { get } from "lodash";

type EventClass = {
    dates: {
        start: string;
    }[];
};

export const sortEventsByDate = <T extends EventClass>(events: T[]): T[] => {
    return events.sort((a: T, b: T) => {
        const aStart = get(a, "dates[0].start");
        const bStart = get(b, "dates[0].start");
        if (!aStart || !bStart) {
            return 0;
        }
        const aDate = new Date(aStart);
        const bDate = new Date(bStart);
        return aDate.getTime() - bDate.getTime();
    }).reverse();
};
